import { ROUTE_QUERY_PARAM } from '../../app/Routes/const';

const tabsEnumValues = [
  'agent',
  'widgetFormSettings',
  'webLinkGenerator',
  'telephony',
] as const;

export type TabsEnum = (typeof tabsEnumValues)[number];

export const AGENT_OUTER_TABS: TabsEnum[] = [...tabsEnumValues];

export const AGENT_TAB_PERSISTENCE_CONFIG = {
  paramName: ROUTE_QUERY_PARAM.TAB_NAME,
  defaultTab: AGENT_OUTER_TABS[0],
  updateHistory: true,
};
